import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfigModule } from '@spartacus/core';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { HeaderNavigationItemModule } from '../../components/header-navigation-item';
import { MenuRegistrationComponent } from './menu-registration.component';

@NgModule({
  declarations: [MenuRegistrationComponent],
  imports: [
    CommonModule,
    I18nModule,
    UrlModule,
    HeaderNavigationItemModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MenuRegistrationComponent: {
          component: MenuRegistrationComponent,
        },
      },
    }),
    RouterModule,
  ],
  providers: [],
  exports: [MenuRegistrationComponent],
})
export class MenuRegistrationModule {}
